import React from 'react'

import { Button, Icon, Row } from 'antd'
import get from 'lodash/get'
import keys from 'lodash/keys'
import startCase from 'lodash/startCase'

import colors from '../../../../../components/hocs/colors'
import { pickWithDefaults, formatFacetKeys } from '../../../../../utils/data/utils'

export default function Filters(props) {
  const defaultProps = {
    checkTopLevelFiltersExists: () => {},
    clearIndividualFilter: () => {},
    clearTopLevelFilters: () => {},
    facets: [],
    loadingGraduateOutcomesOverviewData: false,
    setFiltersDrawerVisible: () => {},
    topLevelFilters: [],
  }

  const {
    topLevelFilters,
    clearIndividualFilter,
    loadingGraduateOutcomesOverviewData,
    clearTopLevelFilters,
    facets,
    checkTopLevelFiltersExists,
    setFiltersDrawerVisible,
  } = pickWithDefaults(props, defaultProps)

  return (
    <Row type="flex" align="middle" justify="end" className="report-width" style={{ rowGap: 6 }}>
      {keys(topLevelFilters)
        .filter(
          metric =>
            !!get(topLevelFilters, metric) &&
            !!get(topLevelFilters, metric, []).length &&
            metric !== '__typename',
        )
        .map(metric => (
          <Button
            key={metric}
            className="filter-chip"
            data-testid="applied-facet-chip"
            onClick={() => clearIndividualFilter(metric)}
            aria-label={`${startCase(formatFacetKeys(metric))}: ${
              get(topLevelFilters, metric, []).length
            } selected, activate to remove filter`}
            shape="round"
            style={{
              backgroundColor: colors.blue3,
              border: `1px solid ${colors.blue3}`,
              borderRadius: 32,
              color: colors.white,
              fontSize: 12,
              marginRight: 5,
              padding: '3px 10px',
            }}
          >
            <span style={{ marginRight: 5 }}>{`${startCase(formatFacetKeys(metric))}: ${
              get(topLevelFilters, metric, []).length
            }`}</span>
            <Icon type="close-circle" theme="twoTone" style={{ fontSize: 12 }} aria-hidden="true" />
          </Button>
        ))}
      <Button
        type="primary"
        loading={loadingGraduateOutcomesOverviewData}
        onClick={() => facets && keys(facets).length && setFiltersDrawerVisible(true)}
        shape="round"
        style={{
          backgroundColor: colors.blue3,
          borderColor: colors.blue3,
          color: colors.white,
          fontSize: 14,
        }}
      >
        <Icon type="plus-circle" aria-hidden="true" />
        Add Filter
      </Button>
      {checkTopLevelFiltersExists(topLevelFilters) && (
        <Button
          onClick={() => clearTopLevelFilters()}
          shape="round"
          style={{
            color: colors.red3,
            fontSize: 14,
            marginLeft: 10,
          }}
        >
          <Icon type="close-circle" aria-hidden="true" />
          Clear All Filters
        </Button>
      )}
    </Row>
  )
}
